import type { InputPuzzle } from "./puzzle.types";

export const NOVICE_PUZZLES: InputPuzzle[] = [
  {
    p: "100460007604971823879230461538620109460189730700540082946052300017800254285314976",
    s: "123468597654971823879235461538627149462189735791543682946752318317896254285314976",
    d: -33820,
  },
  {
    p: "123584069846017025957000481290168537008095040705020896472359610500001270631872954",
    s: "123584769846917325957236481294168537368795142715423896472359618589641273631872954",
    d: -33820,
  },
  {
    p: "003045869004296137976080245050304610631958002842617950305061020017409086468572391",
    s: "123745869584296137976183245759324618631958472842617953395861724217439586468572391",
    d: -33820,
  },
  {
    p: "123708005985260701647301908300400809096125374470839052538040197264917500019083246",
    s: "123798465985264731647351928352476819896125374471839652538642197264917583719583246",
    d: -33820,
  },
  {
    p: "123076094004319720976204318800002641362740859491080273715463980238197400649008000",
    s: "123876594584319726976254318857932641362741859491685273715463982238197465649528137",
    d: -33820,
  },
  {
    p: "020358670697412000508697421800245906263900800459836017712589360006703050385164792",
    s: "124358679697412583538697421871245936263971845459836217712589364946723158385164792",
    d: -33820,
  },
  {
    p: "104360579700900310839507406016743080972856103348291760680035291490082057051079834",
    s: "124368579765924318839517426516743982972856143348291765687435291493182657251679834",
    d: -33820,
  },
  {
    p: "124690803300010402908304050410276385652031947830549621296187504701050268583462000",
    s: "124695873365718492978324156419276385652831947837549621296187534741953268583462719",
    d: -33820,
  },
  {
    p: "120703950560240800078506124987324615456817239213659740042965380635078492090000000",
    s: "124783956569241873378596124987324615456817239213659748742965381635178492891432567",
    d: -33820,
  },
  {
    p: "124870006530460270806925403607039841248150309913648527061582004402796135795300000",
    s: "124873956539461278876925413657239841248157369913648527361582794482796135795314682",
    d: -33820,
  },
  {
    p: "105038060600970520379560481060040152050607849491805730716254398934086200582193674",
    s: "125438967648971523379562481867349152253617849491825736716254398934786215582193674",
    d: -33820,
  },
  {
    p: "125003970803005401904187200092850640631492857048036029487560312219374580000218794",
    s: "125643978873925461964187235792851643631492857548736129487569312219374586356218794",
    d: -33820,
  },
  {
    p: "105703490746192853938650070057901084694000210381047005862310740510470628079826531",
    s: "125783496746192853938654172257961384694538217381247965862315749513479628479826531",
    d: -33820,
  },
  {
    p: "126090374759640108438271695812304957900720816675180243581000069064000580207800431",
    s: "126598374759643128438271695812364957943725816675189243581432769364917582297856431",
    d: -33820,
  },
  {
    p: "126705930800390605903600240230070004004213876678050321400537169769128453315964782",
    s: "126745938847392615953681247231876594594213876678459321482537169769128453315964782",
    d: -33820,
  },
  {
    p: "120895734850074002734026958467901800980000000215738649008213405592467381340089276",
    s: "126895734859374162734126958467951823983642517215738649678213495592467381341589276",
    d: -33820,
  },
  {
    p: "106903087705040310483671952534716290869402500217805634071564820652387109340000005",
    s: "126953487795248316483671952534716298869432571217895634971564823652387149348129765",
    d: -33820,
  },
  {
    p: "127059684039164725465082090316807450970605831584230967790408016251976348040000000",
    s: "127359684839164725465782193316897452972645831584231967793428516251976348648513279",
    d: -33820,
  },
  {
    p: "027539406604210035050476109008005942945721863036084071080143697071092050369857214",
    s: "127539486694218735853476129718365942945721863236984571582143697471692358369857214",
    d: -33820,
  },
  {
    p: "107040869906002305503760100402351698050208403318694257060920530735806924291435786",
    s: "127543869946182375583769142472351698659278413318694257864927531735816924291435786",
    d: -33820,
  },
  {
    p: "127043958093002140008905072371008625246157839905036017012704593039581264654000081",
    s: "127643958593872146468915372371498625246157839985236417812764593739581264654329781",
    d: -33820,
  },
  {
    p: "100659430096380702035700691248035976053807120719040385360908047581473069970502813",
    s: "127659438496381752835724691248135976653897124719246385362918547581473269974562813",
    d: -33820,
  },
  {
    p: "127806900456239178839017642500084207678301450942765381095402000281050704700190523",
    s: "127846935456239178839517642513984267678321459942765381395472816281653794764198523",
    d: -33820,
  },
  {
    p: "120936048358100009069825307712584936000000000536019804045362791673491285291058463",
    s: "127936548358147629469825317712584936984673152536219874845362791673491285291758463",
    d: -33820,
  },
  {
    p: "028007095947152680030849710514060870286974051379518064401725930053496107702000546",
    s: "128637495947152683635849712514263879286974351379518264461725938853496127792381546",
    d: -33820,
  },
  {
    p: "028930607694000013570001840300795002750460198069182305817240036935816724246357981",
    s: "128934657694578213573621849381795462752463198469182375817249536935816724246357981",
    d: -33820,
  },
  {
    p: "129675348054039271703241960568792003400158692912403087375910820891324050000000039",
    s: "129675348654839271783241965568792413437158692912463587375916824891324756246587139",
    d: -33820,
  },
  {
    p: "109680074600097251705231690804903162963712400512846937257360819480000023391520006",
    s: "129685374638497251745231698874953162963712485512846937257364819486179523391528746",
    d: -33820,
  },
  {
    p: "129854730056073908783269541830910465642735089500400073310647092264508300970320050",
    s: "129854736456173928783269541837912465642735189591486273315647892264598317978321654",
    d: -33820,
  },
  {
    p: "109867534000153279530400600901320456263945187458016920682530791305671842014200000",
    s: "129867534846153279537492618971328456263945187458716923682534791395671842714289365",
    d: -33820,
  },
  {
    p: "132090487045713609079824053086137294017040305304002871068379512921405708700001946",
    s: "132596487845713629679824153586137294217948365394652871468379512921465738753281946",
    d: -33820,
  },
  {
    p: "034508002680291054590304060700932581913856007825017609301689425268145970409703806",
    s: "134568792687291354592374168746932581913856247825417639371689425268145973459723816",
    d: -33820,
  },
  {
    p: "104578962590612384206049517602093040048000006070204831453180029721036458869420173",
    s: "134578962597612384286349517612893745348751296975264831453187629721936458869425173",
    d: -33820,
  },
  {
    p: "004002697950637124672490583207865319513920068800173205320740856480310970709250400",
    s: "134582697958637124672491583247865319513924768896173245321749856485316972769258431",
    d: -33820,
  },
  {
    p: "130680079260300481985410362546809137079150248002743956603074015798531604451000003",
    s: "134682579267395481985417362546829137379156248812743956623974815798531624451268793",
    d: -33820,
  },
  {
    p: "134756020856924173927138064710893640093560781602471005278045016001689200000007458",
    s: "134756829856924173927138564715893642493562781682471395278345916541689237369217458",
    d: -33820,
  },
  {
    p: "135874600970205813082193740046759138791380004000421007400517082018042076527638491",
    s: "135874629974265813682193745246759138791386254853421967469517382318942576527638491",
    d: -33820,
  },
  {
    p: "105906000009012304642387190867425913514090287903870046391704802050230671076158439",
    s: "135946728789512364642387195867425913514693287923871546391764852458239671276158439",
    d: -33820,
  },
  {
    p: "136200408754380216890610735605827940073450800428930157047108329209743581300502070",
    s: "136275498754389216892614735615827943973451862428936157547168329269743581381592674",
    d: -33820,
  },
  {
    p: "130280407049657230527314960761493805300065794495728003078500100600042579204971386",
    s: "136289457849657231527314968761493825382165794495728613978536142613842579254971386",
    d: -33820,
  },
  {
    p: "036074092948213507275806304751089203869340051020157689680421930300005128012008476",
    s: "136574892948213567275896314751689243869342751423157689687421935394765128512938476",
    d: -33820,
  },
  {
    p: "130584720070910430490072816341005097589761200267439581618253974923047150050100300",
    s: "136584729872916435495372816341825697589761243267439581618253974923647158754198362",
    d: -33820,
  },
  {
    p: "137408029654329810080071534013964085062800790805207003946580070508102346321746958",
    s: "137458629654329817289671534713964285462835791895217463946583172578192346321746958",
    d: -33820,
  },
  {
    p: "137605042092031065450278913005147089970583006384962100269014508700056291518729004",
    s: "137695842892431765456278913625147389971583426384962157269314578743856291518729634",
    d: -33820,
  },
  {
    p: "107829546459671200026504017094007003600308405302400179243965701065082394918743652",
    s: "137829546459671238826534917594217863671398425382456179243965781765182394918743652",
    d: -33820,
  },
  {
    p: "138400297050182030406007518045673129070951040319824675761238954584700362090500780",
    s: "138465297957182436426397518845673129672951843319824675761238954584719362293546781",
    d: -33820,
  },
  {
    p: "138740092075039016029018743853104679940867305760390481384951267290003004000072938",
    s: "138746592475239816629518743853124679941867325762395481384951267297683154516472938",
    d: -33820,
  },
  {
    p: "139475020052800970847926500001307082028649715760002493504793208206518040983264157",
    s: "139475826652831974847926531491357682328649715765182493514793268276518349983264157",
    d: -33820,
  },
  {
    p: "109486050528179046470052109007904503950713864341508297713645928200830670085007031",
    s: "139486752528179346476352189867924513952713864341568297713645928294831675685297431",
    d: -33820,
  },
  {
    p: "039002540867594012542307600070123965021805003356479128690238750213756090085941200",
    s: "139682547867594312542317689478123965921865473356479128694238751213756894785941236",
    d: -33820,
  },
  {
    p: "102570893030481672876093014681347925059628040720109006598762431003910758407805000",
    s: "142576893935481672876293514681347925359628147724159386598762431263914758417835269",
    d: -33820,
  },
  {
    p: "140080907038000506675090481407169850300874602816352794003425169561937240094618370",
    s: "142586937938741526675293481427169853359874612816352794783425169561937248294618375",
    d: -33820,
  },
  {
    p: "142736958006592143935080026020348090680157234314269500208673009063910870091004365",
    s: "142736958876592143935481726527348691689157234314269587258673419463915872791824365",
    d: -33820,
  },
  {
    p: "102760509753204816680351472064027158217845063800036724971083205406579080500010097",
    s: "142768539753294816689351472364927158217845963895136724971683245426579381538412697",
    d: -33820,
  },
  {
    p: "100805639589316724300942500793684000450109376021053498834267915015438260076590000",
    s: "142875639589316724367942581793684152458129376621753498834267915915438267276591843",
    d: -33820,
  },
  {
    p: "100908756809546031360021008000063002480209567200857314028075143634192875517384629",
    s: "142938756879546231365721498751463982483219567296857314928675143634192875517384629",
    d: -33820,
  },
  {
    p: "103260578500047936697850140931086425008325710025490603206004800854912367319678200",
    s: "143269578582147936697853142931786425468325719725491683276534891854912367319678254",
    d: -33820,
  },
  {
    p: "143689072065702801782541360000000986250967013390010705630270154824153697517490208",
    s: "143689572965732841782541369471325986258967413396814725639278154824153697517496238",
    d: -33820,
  },
  {
    p: "005208936796043018320610047867405192031890460954100083009352671503961000612784359",
    s: "145278936796543218328619547867435192231897465954126783489352671573961824612784359",
    d: -33820,
  },
  {
    p: "140020786820475193937610025281907034790204618504083279310590040079040052458732960",
    s: "145329786826475193937618425281967534793254618564183279312596847679841352458732961",
    d: -33820,
  },
  {
    p: "145789030973265180286143759639010502020950360051326048012008607867592413394600000",
    s: "145789236973265184286143759639814572428957361751326948512438697867592413394671825",
    d: -33820,
  },
  {
    p: "145020690309501024682349150400750010001900370907132540824615739596473281713298400",
    s: "145827693379561824682349157438756912251984376967132548824615739596473281713298465",
    d: -33820,
  },
  {
    p: "140098357758100269900706180469830712570962408280471596694317025805620070027080041",
    s: "146298357758143269932756184469835712571962438283471596694317825815624973327589641",
    d: -33820,
  },
  {
    p: "146908735783145926920763810457319208861257349092480007509630482210000000000092571",
    s: "146928735783145926925763814457319268861257349392486157579631482218574693634892571",
    d: -33820,
  },
  {
    p: "147302596000915700958740120685104937400003800723859460504231609009068374836497215",
    s: "147382596362915748958746123685124937491673852723859461574231689219568374836497215",
    d: -33820,
  },
  {
    p: "008305002670402193300167485204001058581920307739650214816273549407519806953840700",
    s: "148395672675482193392167485264731958581924367739658214816273549427519836953846721",
    d: -33820,
  },
  {
    p: "040506230706312049030047615578630904693428751210059000901074003027165498465893172",
    s: "149586237756312849832947615578631924693428751214759386981274563327165498465893172",
    d: -33820,
  },
  {
    p: "049005320687293100205046080708651430421308509356429871973812605812564003000037218",
    s: "149785326687293154235146987798651432421378569356429871973812645812564793564937218",
    d: -33820,
  },
  {
    p: "052349607876021493493006105508010000640090518319807064284905730060438952935172846",
    s: "152349687876521493493786125528614379647293518319857264284965731761438952935172846",
    d: -33820,
  },
  {
    p: "052079680800321750407685291000857439040963020973140508721530900004216875685794312",
    s: "152479683869321754437685291216857439548963127973142568721538946394216875685794312",
    d: -33820,
  },
  {
    p: "002678004790134002030925071580019620960752348203846105309080450847560219625491783",
    s: "152678934798134562436925871584319627961752348273846195319287456847563219625491783",
    d: -33820,
  },
  {
    p: "050798064370104200804062017789023156615007400403010978237801690541679823968235740",
    s: "152798364376154289894362517789423156615987432423516978237841695541679823968235741",
    d: -33820,
  },
  {
    p: "152970068006815274748632051315408796097160085804007130403050809629780043581349600",
    s: "152974368936815274748632951315428796297163485864597132473256819629781543581349627",
    d: -33820,
  },
  {
    p: "153067489008054321942380607290716843064800075817400962080573216031008504526009738",
    s: "153267489678954321942381657295716843364892175817435962489573216731628594526149738",
    d: -33820,
  },
  {
    p: "150428976620309504940576031076184305380065402415293067562837149734901628800000000",
    s: "153428976627319584948576231276184395389765412415293867562837149734951628891642753",
    d: -33820,
  },
  {
    p: "100728490970156300608904157406587901710392640280041503541203809392865710060419230",
    s: "153728496974156382628934157436587921715392648289641573541273869392865714867419235",
    d: -33820,
  },
  {
    p: "053900724627134589849507030498671352500290047732845196314750208285416973000000000",
    s: "153968724627134589849527631498671352561293847732845196314759268285416973976382415",
    d: -33820,
  },
  {
    p: "153984760728530419000012583010050926586429301239107804962845130375601200801203090",
    s: "153984762728536419694712583417358926586429371239167854962845137375691248841273695",
    d: -33820,
  },
  {
    p: "104027963786931524329605817905213786610408359003596142291054008060300400008160075",
    s: "154827963786931524329645817945213786612478359873596142291754638567382491438169275",
    d: -33820,
  },
  {
    p: "156238490020570816907001253300056008702843509068920104274695381630782945895304600",
    s: "156238497423579816987461253349156728712843569568927134274695381631782945895314672",
    d: -33820,
  },
  {
    p: "006390820907506341030701965841679253320805470670432189762143598410000030003268714",
    s: "156394827987526341234781965841679253329815476675432189762143598418957632593268714",
    d: -33820,
  },
  {
    p: "150907432420506791903421680734209068689370204000864379867040953045098000290753846",
    s: "156987432428536791973421685734219568689375214512864379867142953345698127291753846",
    d: -33820,
  },
  {
    p: "057204960064100008283679104506307892798426531321590740602730009470862015830940627",
    s: "157284963964153278283679154546317892798426531321598746612735489479862315835941627",
    d: -33820,
  },
  {
    p: "107439628089270014043001950900380561871956432060142709032508000010723895598614273",
    s: "157439628689275314243861957924387561871956432365142789732598146416723895598614273",
    d: -33820,
  },
  {
    p: "057690423862374091039215067090180204020006905741052630286037059974521380003869742",
    s: "157698423862374591439215867695183274328746915741952638286437159974521386513869742",
    d: -33820,
  },
  {
    p: "057924000002073091960001420018562943390048216406319805271435689039287150084196730",
    s: "157924368842673591963851427718562943395748216426319875271435689639287154584196732",
    d: -33820,
  },
  {
    p: "107904682234085190080020530573290046642358719819470253068719025005803960390560470",
    s: "157934682234685197986127534573291846642358719819476253468719325725843961391562478",
    d: -33820,
  },
  {
    p: "150034769070819254904750003480627915291345806065981342819560407030400000607192538",
    s: "158234769376819254924756183483627915291345876765981342819563427532478691647192538",
    d: -33820,
  },
  {
    p: "158034067290760140764905832682040579310576420507800603000029306036407291921683754",
    s: "158234967293768145764915832682341579319576428547892613475129386836457291921683754",
    d: -33820,
  },
  {
    p: "050067204347950068060408573836005409501890630002100857020783941983541726714629385",
    s: "158367294347952168269418573836275419571894632492136857625783941983541726714629385",
    d: -33820,
  },
  {
    p: "058470020390125780047063059010596230580042671632781490005907863870054012961238547",
    s: "158479326396125784247863159714596238589342671632781495425917863873654912961238547",
    d: -33820,
  },
  {
    p: "100060432739210058000083179401005283590842061802371594086127940245906817917458300",
    s: "158769432739214658624583179471695283593842761862371594386127945245936817917458326",
    d: -33820,
  },
  {
    p: "150407638062018759387065214536071092928040107700090385691000503005039846843756921",
    s: "159427638462318759387965214536871492928543167714692385691284573275139846843756921",
    d: -33820,
  },
  {
    p: "059483206470056901026907530782361495001508720300792018010679042934120867260830159",
    s: "159483276473256981826917534782361495691548723345792618518679342934125867267834159",
    d: -33820,
  },
  {
    p: "159834072768152390342069581090003010200500438510008967005917826901420753027385149",
    s: "159834672768152394342769581894673215276591438513248967435917826981426753627385149",
    d: -33820,
  },
  {
    p: "162007050890034762304602098648000937010708246029046581086521473401073609237469815",
    s: "162987354895134762374652198648215937513798246729346581986521473451873629237469815",
    d: -33820,
  },
  {
    p: "103789400205400876070256931086090752537042169910075300341000297750920613629137584",
    s: "163789425295413876874256931486391752537842169912675348341568297758924613629137584",
    d: -33820,
  },
  {
    p: "063872045504913768987560320609751084471286539800000607748620093295030406310090852",
    s: "163872945524913768987564321639751284471286539852349617748625193295138476316497852",
    d: -33820,
  },
  {
    p: "064537009097814005853260014385026471609451283021083950918075042036142000002398167",
    s: "164537829297814635853269714385926471679451283421783956918675342736142598542398167",
    d: -33820,
  },
  {
    p: "164728350075310684890405271630591742452800913910034568780003105001980036046002897",
    s: "164728359275319684893465271638591742452876913917234568789643125521987436346152897",
    d: -33820,
  },
  {
    p: "160930072908620401423170960010283506346519728582046193807460310631007204294350600",
    s: "165934872978625431423178965719283546346519728582746193857462319631897254294351687",
    d: -33820,
  },
  {
    p: "100983024987140035304576981218705403049008172670021859892604500406207398701059206",
    s: "165983724987142635324576981218795463549368172673421859892634517456217398731859246",
    d: -33820,
  },
  {
    p: "167045839852319746049700020698523407513074062704190583981652300400901200000487691",
    s: "167245839852319746349768125698523417513874962724196583981652374476931258235487691",
    d: -33820,
  },
  {
    p: "007205403832604095945080261601850004294076358050942176420569807700021530519738642",
    s: "167295483832614795945387261671853924294176358358942176423569817786421539519738642",
    d: -33820,
  },
  {
    p: "107928340004573206203164078735490180418052769692781534801039457500210090070805021",
    s: "167928345984573216253164978735496182418352769692781534821639457546217893379845621",
    d: -33820,
  },
  {
    p: "168275093290006058057800621632754809005001004814960370500647932029138546346529180",
    s: "168275493293416758457893621632754819975381264814962375581647932729138546346529187",
    d: -33820,
  },
  {
    p: "068934250070856490450270683613405079807019062095000314986142730504790020721563948",
    s: "168934257372856491459271683613425879847319562295687314986142735534798126721563948",
    d: -33820,
  },
  {
    p: "160005043032604719007310586826753491915428067074069850681247005743591628259000000",
    s: "168975243532684719497312586826753491915428367374169852681247935743591628259836174",
    d: -33820,
  },
  {
    p: "169058004754139826230670019680000142410702963923406000841563297006807031072941658",
    s: "169258374754139826238674519687395142415782963923416785841563297596827431372941658",
    d: -33820,
  },
  {
    p: "109080503040900786738652904472590361913064805586371249301805607897006400004729138",
    s: "169487523245913786738652914472598361913264875586371249321845697897136452654729138",
    d: -33820,
  },
  {
    p: "069534820523678901487291635906152478740380192812947350698023504051060703300000000",
    s: "169534827523678941487291635936152478745386192812947356698723514251469783374815269",
    d: -33820,
  },
  {
    p: "070360985483105620560800134090403568806720041310658702601907400745236819938541206",
    s: "172364985483195627569872134297413568856729341314658792621987453745236819938541276",
    d: -33820,
  },
  {
    p: "170598364640107209903240517304850670800009435027364090010485923259670148030912756",
    s: "172598364645137289983246517394851672861729435527364891716485923259673148438912756",
    d: -33820,
  },
  {
    p: "172600459395124700046095012769041023230078504058360970084259137920817645517400008",
    s: "172683459395124786846795312769541823231978564458362971684259137923817645517436298",
    d: -33820,
  },
  {
    p: "102034560009560042006827300365418297217395604948276103004750831781643925593100000",
    s: "172934568839561742456827319365418297217395684948276153624759831781643925593182476",
    d: -33820,
  },
  {
    p: "172936458503082907900751002804105379350070061006329005001540723207613594435297186",
    s: "172936458563482917948751632824165379359874261716329845691548723287613594435297186",
    d: -33820,
  },
  {
    p: "170080645468021309005007821759642138003715000021390754384156207517039486090074513",
    s: "172983645468521379935467821759642138843715962621398754384156297517239486296874513",
    d: -33820,
  },
  {
    p: "103428050269375008008190723736050219410209830800010504650941382320680495984532671",
    s: "173428956269375148548196723736854219415269837892713564657941382321687495984532671",
    d: -33820,
  },
  {
    p: "173648009496257830800301007238405076049863512650709008314986725087030690002574183",
    s: "173648259496257831825391467238415976749863512651729348314986725587132694962574183",
    d: -33820,
  },
  {
    p: "074230800802450761590817430418700623705643918900182574387561249059000186601908050",
    s: "174236895832459761596817432418795623725643918963182574387561249259374186641928357",
    d: -33820,
  },
  {
    p: "100006920628914570093287146406070092935460810712839654257098430369741005040003769",
    s: "174356928628914573593287146486175392935462817712839654257698431369741285841523769",
    d: -33820,
  },
  {
    p: "004598623590604007826001905752146000619837254348952716035209801087003502260785409",
    s: "174598623593624187826371945752146398619837254348952716435269871987413562261785439",
    d: -33820,
  },
  {
    p: "175834069960052074420096185051300628036508400894207013000403701307685942542971836",
    s: "175834269968152374423796185751349628236518497894267513689423751317685942542971836",
    d: -33820,
  },
  {
    p: "076304295583012607040050081710596420652038719934271800321865974095703100060149032",
    s: "176384295583912647249657381718596423652438719934271856321865974495723168867149532",
    d: -33820,
  },
  {
    p: "170408509090136847348057162420815976907640080605702010001060708769281453854379620",
    s: "176428539592136847348957162423815976917643285685792314231564798769281453854379621",
    d: -33820,
  },
  {
    p: "106058329345921006809760400500874602784602001630519084208305960950106243463297158",
    s: "176458329345921876829763415591874632784632591632519784218345967957186243463297158",
    d: -33820,
  },
  {
    p: "176532948080149765405768002720405816648201309519386274054000093937004580860900407",
    s: "176532948382149765495768132723495816648271359519386274254817693937624581861953427",
    d: -33820,
  },
  {
    p: "106020040598070200203056817360205790912387450857069321409531672021648905035092184",
    s: "176823549598174263243956817364215798912387456857469321489531672721648935635792184",
    d: -33820,
  },
  {
    p: "076802030934015682508640901213586740467009850859407126685371294342008017790200008",
    s: "176892435934715682528643971213586749467129853859437126685371294342968517791254368",
    d: -33820,
  },
  {
    p: "178235040430108275060940031051600982796821403002093167080319726923786504617002390",
    s: "178235649439168275265947831351674982796821453842593167584319726923786514617452398",
    d: -33820,
  },
  {
    p: "178325604090718523003694170560809431481530069937046285716403952020961847049000000",
    s: "178325694694718523253694178562879431481532769937146285716483952325961847849257316",
    d: -33820,
  },
  {
    p: "178329604305417008429568103290601305016832740783900061800790532602104090057283416",
    s: "178329654365417928429568173294671385516832749783945261841796532632154897957283416",
    d: -33820,
  },
  {
    p: "070356904040000315320491680761249508280630740034017296890064070612978453457123860",
    s: "178356924946782315325491687761249538289635741534817296893564172612978453457123869",
    d: -33820,
  },
  {
    p: "008609020005018600469200138806304201741592863520860749902086014607943582384125976",
    s: "178639425235418697469257138896374251741592863523861749952786314617943582384125976",
    d: -33820,
  },
  {
    p: "178059203025803976369742581237461009500008630086537124813206090794085060602094708",
    s: "178659243425813976369742581237461859541928637986537124813276495794185362652394718",
    d: -33820,
  },
  {
    p: "179365048403092516006184703890507630054931802732840059367059481000403965945618000",
    s: "179365248483792516526184793891527634654931872732846159367259481218473965945618327",
    d: -33820,
  },
  {
    p: "179534862203860471408710503720081009936075184000690257017320906690057320082946715",
    s: "179534862253869471468712593725481639936275184841693257517328946694157328382946715",
    d: -33820,
  },
  {
    p: "182469070060208419749035082604592031010347250035000794457923168091054327300081945",
    s: "182469573563278419749135682674592831918347256235816794457923168891654327326781945",
    d: -33820,
  },
  {
    p: "080070059300528714040691028006900175500736402270145063620819507817354296954267831",
    s: "182473659369528714745691328436982175591736482278145963623819547817354296954267831",
    d: -33820,
  },
  {
    p: "183295470794618250526043091239154687475836902860072530957001368348000000000300745",
    s: "183295476794618253526743891239154687475836912861972534957421368348567129612389745",
    d: -33820,
  },
  {
    p: "183047096695123480042809513251008000360075129070001860439702650520980731817356942",
    s: "183547296695123487742869513251698374368475129974231865439712658526984731817356942",
    d: -33820,
  },
  {
    p: "083560702604273015205041063700495386059780021046130500527914600968327004431658297",
    s: "183569742694273815275841963712495386359786421846132579527914638968327154431658297",
    d: -33820,
  },
  {
    p: "103900650950000237427365098218754963365298741794136825800419006609503000000627389",
    s: "183972654956841237427365198218754963365298741794136825832419576679583412541627389",
    d: -33820,
  },
  {
    p: "104003675597416820026857910871634590043582107652971430708065240460008300000149786",
    s: "184293675597416823326857914871634592943582167652971438718365249469728351235149786",
    d: -33820,
  },
  {
    p: "180027390309845160260093004001086720427509618806712409513204080602378041748951236",
    s: "184627395379845162265193874951486723427539618836712459513264987692378541748951236",
    d: -33820,
  },
  {
    p: "184900365975316482032580179596801037827000501013702896201408753340270000008163924",
    s: "184927365975316482632584179596841237827639541413752896261498753349275618758163924",
    d: -33820,
  },
  {
    p: "106450030007016845530892617975623104810904350640185970309040720051039468428761093",
    s: "186457239297316845534892617975623184812974356643185972369548721751239468428761593",
    d: -33820,
  },
  {
    p: "007460930960271584540900761290734856854620317736158249478396105019542008000010003",
    s: "187465932963271584542983761291734856854629317736158249478396125319542678625817493",
    d: -33820,
  },
  {
    p: "187963025034572800526148079269314058478000160315786094041050600852000047603427581",
    s: "187963425934572816526148379269314758478295163315786294741859632852631947693427581",
    d: -33820,
  },
  {
    p: "089305247034871569576294183003120895751086304892453671008019406905000700060032918",
    s: "189365247234871569576294183643127895751986324892453671328719456915648732467532918",
    d: -33820,
  },
  {
    p: "109026703003950601040001829731605204690340185458019376927064508010092467864573912",
    s: "189426753273958641546731829731685294692347185458219376927164538315892467864573912",
    d: -33820,
  },
  {
    p: "189647523256931008007520001875094102634150980920076350712469835508000476463085200",
    s: "189647523256931748347528691875394162634152987921876354712469835598213476463785219",
    d: -33820,
  },
  {
    p: "190750006784362915006490780679014520400935067350627194840279651065143200217006409",
    s: "192758346784362915536491782679814523421935867358627194843279651965143278217586439",
    d: -33820,
  },
  {
    p: "193200780527380049600107302002863915315900807869571234951632000438759620276418000",
    s: "193245786527386149684197352742863915315924867869571234951632478438759621276418593",
    d: -33820,
  },
  {
    p: "193600578647158230050793614024006050006500702519204086872005193005381427431927865",
    s: "193642578647158239258793614724836951386519742519274386872465193965381427431927865",
    d: -33820,
  },
  {
    p: "190785062647392580028104397716048030034576218280000740069857104870409600452031879",
    s: "193785462647392581528164397716248935934576218285913746369857124871429653452631879",
    d: -33820,
  },
  {
    p: "194350780028106530360900420901004673406813052253069014637090140042071398819435267",
    s: "194352786728146539365987421981524673476813952253769814637298145542671398819435267",
    d: -33820,
  },
  {
    p: "190005873002978105508013920439056010805091364607034509701360098280549731943187652",
    s: "194625873362978145578413926439856217825791364617234589751362498286549731943187652",
    d: -33820,
  },
  {
    p: "190675803327800560050123007070358614610790380483206795032087156748561239501900470",
    s: "194675823327849561856123947279358614615794382483216795932487156748561239561932478",
    d: -33820,
  },
  {
    p: "195287004080940521432615008246008157873560249519024806068432015304079080000856493",
    s: "195287364687943521432615978246398157873561249519724836968432715354179682721856493",
    d: -33820,
  },
  {
    p: "195876302803201059274593068746350901000714003321968475457100830930687504018030097",
    s: "195876342863241759274593168746352981589714623321968475457129836932687514618435297",
    d: -33820,
  },
  {
    p: "096345207405682193820091450502400678640278315738516924307920861000067502000853049",
    s: "196345287475682193823791456512439678649278315738516924357924861984167532261853749",
    d: -33820,
  },
  {
    p: "190358270048762901720910568010829050009647182287035400931486725872590643460073000",
    s: "196358274548762931723914568614829357359647182287135496931486725872591643465273819",
    d: -33820,
  },
  {
    p: "106450070425783601038900045601249783872635019943817560019370854007000900364598127",
    s: "196452378425783691738961245651249783872635419943817562219376854587124936364598127",
    d: -33820,
  },
  {
    p: "096480235327069481845020769054976803631008074089314526060035140003840697408601052",
    s: "196487235327569481845123769254976813631258974789314526962735148513842697478691352",
    d: -33820,
  },
  {
    p: "196584307257300064843602519010908736030100285700235491685413970329756000470820603",
    s: "196584327257391864843672519512948736934167285768235491685413972329756148471829653",
    d: -33820,
  },
  {
    p: "096730052784250613050608047007306085528040006361587294815402039639070028472893561",
    s: "196734852784259613253618947947326185528941376361587294815462739639175428472893561",
    d: -33820,
  },
  {
    p: "197300006028406005600187093403210850902870001871635942514728369009560714736941528",
    s: "197352486328496175645187293463219857952874631871635942514728369289563714736941528",
    d: -33820,
  },
  {
    p: "107528043263490810485361290604179082902853104510046370020034958346985720850000036",
    s: "197528643263497815485361297634179582972853164518246379721634958346985721859712436",
    d: -33820,
  },
  {
    p: "097820365430605718685130249764319502000208007320756401871462900256983104903501020",
    s: "197824365432695718685137249764319582519248637328756491871462953256983174943571826",
    d: -33820,
  },
  {
    p: "198057624047820531253641908004782053302506407015904286030465010506173049471200065",
    s: "198357624647829531253641978964782153382516497715934286839465712526173849471298365",
    d: -33820,
  },
  {
    p: "198300406256841073703296081481520367360410002527038149835002790004903000912754638",
    s: "198375426256841973743296581481529367369417852527638149835162794674983215912754638",
    d: -33820,
  },
  {
    p: "098625743742100609360400210521849370473206801086731025010000537659370102207518964",
    s: "198625743742183659365497218521849376473256891986731425814962537659374182237518964",
    d: -33820,
  },
  {
    p: "098725603720639508653081927387052461010068795509174380241003876806247100070000234",
    s: "198725643724639518653481927387952461412368795569174382241593876836247159975816234",
    d: -33820,
  },
  {
    p: "210007004896243570745189020102396457370500260004872139038465702450921300621708945",
    s: "213657894896243571745189623182396457379514268564872139938465712457921386621738945",
    d: -33820,
  },
  {
    p: "213096547040375081750421693987062314300148720004739865091683400002004000436217958",
    s: "213896547649375281758421693987562314365148729124739865591683472872954136436217958",
    d: -33820,
  },
  {
    p: "014008790936257100507940360895300427621070938073890516758103640042569071109704253",
    s: "214638795936257184587941362895316427621475938473892516758123649342569871169784253",
    d: -33820,
  },
  {
    p: "210980300038006759769530081193765400604002070827341690981623507302459816506108932",
    s: "215987364438216759769534281193765428654892173827341695981623547372459816546178932",
    d: -33820,
  },
  {
    p: "206503970308294056040176328724008500539010680061902740657041209493025817182739460",
    s: "216583974378294156945176328724368591539417682861952743657841239493625817182739465",
    d: -33820,
  },
  {
    p: "216730895497582163580169704160058372342901006008023041024317608601040230835096400",
    s: "216734895497582163583169724169458372342971586758623941924317658671845239835296417",
    d: -33820,
  },
  {
    p: "010735940739184026405290173807052314540871269060349085951407832370528691620000000",
    s: "216735948739184526485296173897652314543871269162349785951467832374528691628913457",
    d: -33820,
  },
  {
    p: "006938457938070062574201083082310605091652738653407010800125374120843506005096821",
    s: "216938457938574162574261983782319645491652738653487219869125374127843596345796821",
    d: -33820,
  },
  {
    p: "207408960490060802856129347781640203035200074642793008368074521509002006124856739",
    s: "217438965493567812856129347781645293935281674642793158368974521579312486124856739",
    d: -33820,
  },
  {
    p: "217468359936210748805703002300100685680502497074906010708300920003659874469827531",
    s: "217468359936215748845793162392174685681532497574986213758341926123659874469827531",
    d: -33820,
  },
  {
    p: "000605340390012857040700126620108473070004590453927681732841960504293718081576234",
    s: "217685349396412857845739126629158473178364592453927681732841965564293718981576234",
    d: -33820,
  },
  {
    p: "210300040463070501597004086006120934904600175731905062100793658675481293389562417",
    s: "218356749463879521597214386856127934924638175731945862142793658675481293389562417",
    d: -33820,
  },
  {
    p: "018056473543278916079301500384710020965803140721469358056130290400592001002684035",
    s: "218956473543278916679341582384715629965823147721469358856137294437592861192684735",
    d: -33820,
  },
  {
    p: "209076008085140930340908200728639140051807690936514872174065309592083760003791524",
    s: "219376458685142937347958216728639145451827693936514872174265389592483761863791524",
    d: -33820,
  },
  {
    p: "019036840546807931387914526123609080860170200075208003050362179701005062632791458",
    s: "219536847546827931387914526123659784864173295975248613458362179791485362632791458",
    d: -33820,
  },
  {
    p: "019007305804500971537491602072906810900318260681074093490130756753649120126005439",
    s: "219867345864523971537491682372956814945318267681274593498132756753649128126785439",
    d: -33820,
  },
  {
    p: "231496758800520061560381294703064815415208970986175402008752003304810627170600009",
    s: "231496758849527361567381294723964815415238976986175432698752143354819627172643589",
    d: -33820,
  },
  {
    p: "231097658740058309598613742302946175679180420154002086927064531813009000000301097",
    s: "231497658746258319598613742382946175679185423154732986927864531813579264465321897",
    d: -33820,
  },
  {
    p: "201685709000943621490172308862451970150239804349700215025817436714096582080000007",
    s: "231685749578943621496172358862451973157239864349768215925817436714396582683524197",
    d: -33820,
  },
  {
    p: "030176589150209000607583104301052046405860391906310802700628030862435917543791268",
    s: "234176589158249673697583124381952746425867391976314852719628435862435917543791268",
    d: -33820,
  },
  {
    p: "234071859010300267006082310560719482920030671147800935671243098002957146459168000",
    s: "234671859815394267796582314563719482928435671147826935671243598382957146459168723",
    d: -33820,
  },
  {
    p: "230609517087140360691500002826495031375218690410360258040706903060034175703921486",
    s: "234689517587142369691573842826495731375218694419367258148756923962834175753921486",
    d: -33820,
  },
  {
    p: "034690008009302645500007390453800126910503804786241903600028539125936487398754261",
    s: "234695718879312645561487392453879126912563874786241953647128539125936487398754261",
    d: -33820,
  },
  {
    p: "030697851860314079719002034602705093390040007571230486903421768020008315187563942",
    s: "234697851865314279719852634642785193398146527571239486953421768426978315187563942",
    d: -33820,
  },
  {
    p: "235178000178009023904305780002701054846592007510034096423950078651487930789213465",
    s: "235178649178649523964325781392761854846592317517834296423956178651487932789213465",
    d: -33820,
  },
  {
    p: "235491078764083195891056423526078930089600010010930856150869247040000061072514389",
    s: "235491678764283195891756423526178934389645712417932856153869247948327561672514389",
    d: -33820,
  },
  {
    p: "200719846908364570476208109167092300820570601503146287609481723742635918380000000",
    s: "235719846918364572476258139167892354824573691593146287659481723742635918381927465",
    d: -33820,
  },
  {
    p: "230741896840205370700839542456108723028503964000000080073012408082354617514687239",
    s: "235741896849265371761839542456198723128573964397426185673912458982354617514687239",
    d: -33820,
  },
  {
    p: "235847601170503248486190073814026705052730486067485109703610954690250010541300800",
    s: "235847691179563248486192573814926735952731486367485129723618954698254317541379862",
    d: -33820,
  },
  {
    p: "235000100679040328408030960824063751590120006301754080906312547750489613143675892",
    s: "235896174679541328418237965824963751597128436361754289986312547752489613143675892",
    d: -33820,
  },
  {
    p: "230450809791862030584007062620174395175300240903025700809043007052786913367519428",
    s: "236451879791862534584937162628174395175398246943625781819243657452786913367519428",
    d: -33820,
  },
  {
    p: "236004175984005030571326849420517096060200781007003024602058913709632450853491267",
    s: "236984175984175632571326849428517396365249781197863524642758913719632458853491267",
    d: -33820,
  },
  {
    p: "207409058961057230805326971304905126106732549029640307403000005000174893798563412",
    s: "237419658961857234845326971374985126186732549529641387413298765652174893798563412",
    d: -33820,
  },
  {
    p: "230458961006390425049210378308500002400921836920863704050709600780635219693142587",
    s: "237458961816397425549216378368574192475921836921863754152789643784635219693142587",
    d: -33820,
  },
  {
    p: "230015080618340920945608031050184200124563079306092514802031600470256308563879142",
    s: "237915486618347925945628731759184263124563879386792514892431657471256398563879142",
    d: -33820,
  },
  {
    p: "239465107010703502475182900060879453008350609950604718027918364684007091391246800",
    s: "239465187816793542475182936162879453748351629953624718527918364684537291391246875",
    d: -33820,
  },
  {
    p: "209067581018350940456908270500706328962180007380240060023579810175034602894621735",
    s: "239467581718352946456918273541796328962183457387245169623579814175834692894621735",
    d: -33820,
  },
  {
    p: "239405680405068793086093452820036904960841275541729308378002049652984007090050820",
    s: "239475681415268793786193452827536914963841275541729368378612549652984137194357826",
    d: -33820,
  },
  {
    p: "209754861560821409841693572405208396680379004093046280720005918000060700314987625",
    s: "239754861567821439841693572475218396682379154193546287726435918958162743314987625",
    d: -33820,
  },
  {
    p: "241350067860729541950416038510087493372594086489160725190672300635941802020000000",
    s: "241358967863729541957416238516287493372594186489163725198672354635941872724835619",
    d: -33820,
  },
  {
    p: "241638507983070612507219348198065724305047961074920853759180036816493200000000009",
    s: "241638597983574612567219348198365724325847961674921853759182436816493275432756189",
    d: -33820,
  },
  {
    p: "241097080308142700796380241934250108005931402612470539107860953589013620460529000",
    s: "241697385358142796796385241934256178875931462612478539127864953589713624463529817",
    d: -33820,
  },
  {
    p: "001793568563080179789560342050310086637948250198652730820409610370100805916800023",
    s: "241793568563284179789561342452317986637948251198652734825439617374126895916875423",
    d: -33820,
  },
  {
    p: "240650809850294163691308045516937482320416957900000316465820701089763524700045000",
    s: "243651879857294163691378245516937482328416957974582316465829731189763524732145698",
    d: -33820,
  },
  {
    p: "200710065617854092859263471460578239728301546305042710074126983906035127000000600",
    s: "243719865617854392859263471461578239728391546395642718574126983986435127132987654",
    d: -33820,
  },
  {
    p: "243750180700839524950421376384972600027365940690084037430617852570290063862500000",
    s: "243756189716839524958421376384972615127365948695184237439617852571298463862543791",
    d: -33820,
  },
  {
    p: "240900715197034082580127349854719260310402807072853194438290006000378401700645038",
    s: "243986715197534682586127349854719263319462857672853194438291576965378421721645938",
    d: -33820,
  },
  {
    p: "245103609601894752900520130769205803413008527002430900326781095157309068894652001",
    s: "245173689631894752978526134769215843413968527582437916326781495157349268894652371",
    d: -33820,
  },
  {
    p: "240391786106857040978642305000138960300004850681529003564073128710080634820416597",
    s: "245391786136857249978642315457138962392764851681529473564973128719285634823416597",
    d: -33820,
  },
  {
    p: "245089173380407259079002846000300081793861425850294367538020794962743510407950000",
    s: "245689173386417259179532846624375981793861425851294367538126794962743518417958632",
    d: -33820,
  },
  {
    p: "240837601708569304369142587900350178137928456584601930491785203672400000000000749",
    s: "245837691718569324369142587926354178137928456584671932491785263672493815853216749",
    d: -33820,
  },
  {
    p: "046100853790520001581364002025003069134689027967215008450830016008746295672951384",
    s: "246197853793528641581364972825473169134689527967215438459832716318746295672951384",
    d: -33820,
  },
  {
    p: "046357891501640723873129056657493182018702300324805960065930008482070600030086574",
    s: "246357891591648723873129456657493182918762345324815967765934218482571639139286574",
    d: -33820,
  },
  {
    p: "247630518168540020395210467630801754850476290724050680080795132503002046000364875",
    s: "247639518168547329395218467639821754851476293724953681486795132573182946912364875",
    d: -33820,
  },
  {
    p: "247653981980740306356980724090106045015298607702430198500309462030020009129864573",
    s: "247653981981742356356981724893176245415298637762435198578319462634527819129864573",
    d: -33820,
  },
  {
    p: "048930067017560480596870012053627094609148035874359126400793651735016940961400000",
    s: "248931567317562489596874312153627894629148735874359126482793651735216948961485273",
    d: -33820,
  },
  {
    p: "249780031700304509513096087986501042000928156100060093852673904371840205694152378",
    s: "249785631768314529513296487986531742437928156125467893852673914371849265694152378",
    d: -33820,
  },
  {
    p: "251068497483795026007200058312079860906853241548620973724106539139540680005030000",
    s: "251368497483795126697214358312479865976853241548621973724186539139547682865932714",
    d: -33820,
  },
  {
    p: "201378046976020813800900702028006407369457100704009630102695374695743281437812509",
    s: "251378946976524813843961752528136497369457128714289635182695374695743281437812569",
    d: -33820,
  },
  {
    p: "051690407479800035360740002706032519140956370930108046524380061810204953693517824",
    s: "251693487479821635368745192786432519142956378935178246524389761817264953693517824",
    d: -33820,
  },
  {
    p: "251800093963712000470935000340059178605087402017243056089326010526471089134598267",
    s: "251864793963712845478935621342659178695187432817243956789326514526471389134598267",
    d: -33820,
  },
  {
    p: "253107948697840102814952376009080023368294715420731869931570204786400031500010000",
    s: "253167948697843152814952376179685423368294715425731869931576284786429531542318697",
    d: -33820,
  },
  {
    p: "253918006810304592074256831025491368381762459649830127430627005567049003100000000",
    s: "253918746816374592974256831725491368381762459649835127438627915567149283192583674",
    d: -33820,
  },
  {
    p: "054301698830624571176085023500060239027543106308192050702030905685219300490756812",
    s: "254371698839624571176985423541867239927543186368192754712438965685219347493756812",
    d: -33820,
  },
  {
    p: "254398067796251843183674590502860914831409750649705200017032085060180029000500371",
    s: "254398167796251843183674592572863914831429756649715238417932685365187429928546371",
    d: -33820,
  },
  {
    p: "054678090713925084980134527170462935690703801435819206369241000840590062027380000",
    s: "254678193713925684986134527178462935692753841435819276369241758841597362527386419",
    d: -33820,
  },
  {
    p: "254679138016408759907513206490087503573061820600054917030042685862735491145000000",
    s: "254679138316428759987513246491287563573961824628354917739142685862735491145896372",
    d: -33820,
  },
  {
    p: "054000913036509728970312065041253800723068541005471600480136257517824390062005184",
    s: "254687913136549728978312465641253879723968541895471632489136257517824396362795184",
    d: -33820,
  },
  {
    p: "004738691167924308930561720516000400489007205372045189803409510090253847745086930",
    s: "254738691167924358938561724516892473489317265372645189823479516691253847745186932",
    d: -33820,
  },
  {
    p: "254001983613089705897030612002195867065827439789000521900403108370658204508902076",
    s: "254761983613289745897534612432195867165827439789346521926473158371658294548912376",
    d: -33820,
  },
  {
    p: "204836971160047500090251463541763029920580136836190740619378250375429010080600090",
    s: "254836971163947582798251463541763829927584136836192745619378254375429618482615397",
    d: -33820,
  },
  {
    p: "250197800709000520318005967693510278572830419481072605037469152165028394904051000",
    s: "256197843749683521318245967693514278572836419481972635837469152165728394924351786",
    d: -33820,
  },
  {
    p: "250741900040932650193658427681524739934876002570193846029487165068200004405300000",
    s: "256741983847932651193658427681524739934876512572193846329487165768215394415369278",
    d: -33820,
  },
  {
    p: "056700300703016290810000460102407506364285971597163824428631759971028603600970182",
    s: "256749318743816295819352467182497536364285971597163824428631759971528643635974182",
    d: -33820,
  },
  {
    p: "257418360364205718980306054816052493420160805573809621732501040198000037005900182",
    s: "257418369364295718981376254816752493429163875573849621732581946198624537645937182",
    d: -33820,
  },
  {
    p: "257618000630900128000243576702051863503789412148306705321894657005160389900530041",
    s: "257618934634975128819243576792451863563789412148326795321894657475162389986537241",
    d: -33820,
  },
  {
    p: "257001349034507682600230510840976153070145068561823974086352491310468725405000000",
    s: "257681349134597682698234517842976153973145268561823974786352491319468725425719836",
    d: -33820,
  },
  {
    p: "258174396007296408469000172800512064142609085590487030905721640031905820720068519",
    s: "258174396317296458469853172873512964142639785596487231985721643631945827724368519",
    d: -33820,
  },
  {
    p: "258360917610075023097008604581047392940512780760800145105406278409203061820751039",
    s: "258364917614975823397128654581647392943512786762839145135496278479283561826751439",
    d: -33820,
  },
  {
    p: "250610479367509281019870350136425807080196540045738602004051728500080164071264930",
    s: "258613479367549281419872356136425897782196543945738612694351728523987164871264935",
    d: -33820,
  },
  {
    p: "258709316973105040160280579000007693635018720049630105482576931000820457507394862",
    s: "258749316973165248164283579821457693635918724749632185482576931396821457517394862",
    d: -33820,
  },
  {
    p: "059100700341620098768409310593768021426900837187234609674391080012576943035802000",
    s: "259183764341627598768459312593768421426915837187234659674391285812576943935842176",
    d: -33820,
  },
  {
    p: "250613478041008632083400105800249560002370804436080027900764351164032789375891246",
    s: "259613478741958632683427195817249563592376814436185927928764351164532789375891246",
    d: -33820,
  },
  {
    p: "059784100400310058381056020630147092174009035028563407716030289890271546502698371",
    s: "259784163467312958381956724635147892174829635928563417716435289893271546542698371",
    d: -33820,
  },
  {
    p: "060430098384702501950681234030870010472060803198053647020040105615328479849517326",
    s: "261435798384792561957681234536874912472169853198253647723946185615328479849517326",
    d: -33820,
  },
  {
    p: "061583974893207561750691382927364815340900027018750030589120740076030008032009156",
    s: "261583974893247561754691382927364815345918627618752439589126743176435298432879156",
    d: -33820,
  },
  {
    p: "000930004430008002500004371312756049078421035045009127853172496124693758796845213",
    s: "261937584437518962589264371312756849978421635645389127853172496124693758796845213",
    d: -33820,
  },
  {
    p: "261045300845673009039102456483751690956234780172869043018500030500318960397020015",
    s: "261945378845673129739182456483751692956234781172869543618597234524318967397426815",
    d: -33820,
  },
  {
    p: "263508419708609203945312670300896041094057080080400702037964105050123867621785934",
    s: "263578419718649253945312678372896541194257386586431792837964125459123867621785934",
    d: -33820,
  },
  {
    p: "263785014089340756475901283852476091630009842014230567540823609396510028720000000",
    s: "263785914189342756475961283852476391637159842914238567541823679396517428728694135",
    d: -33820,
  },
  {
    p: "260859071758416092900302805182704530504263918039581704427035189805007003396100207",
    s: "263859471758416392941372865182794536574263918639581724427635189815927643396148257",
    d: -33820,
  },
  {
    p: "264351987589046103300802465642170830090283546005469200973528614458017302120000008",
    s: "264351987589746123317892465642175839791283546835469271973528614458617392126934758",
    d: -33820,
  },
  {
    p: "204391807751080039809574010378026501045900008092750060007145683483269175516837942",
    s: "264391857751682439839574216378426591645913728192758364927145683483269175516837942",
    d: -33820,
  },
  {
    p: "000500000971438502385609147008367290026194783709852416607213804852940371100085629",
    s: "264571938971438562385629147418367295526194783739852416697213854852946371143785629",
    d: -33820,
  },
  {
    p: "260093081807420903100568402512370849630184257408259036045900618981647025320805700",
    s: "264793581857421963193568472512376849639184257478259136745932618981647325326815794",
    d: -33820,
  },
  {
    p: "260480703489067521731590864307106958090825317510973246152030089876009400003008172",
    s: "265481793489367521731592864327146958694825317518973246152734689876219435943658172",
    d: -33820,
  },
  {
    p: "065091374187034629390670080023950006079146832806327905730065198648009253951283000",
    s: "265891374187534629394672581423958716579146832816327945732465198648719253951283467",
    d: -33820,
  },
  {
    p: "267001509103425068804960132026584971048710050571206004439650817085179423702000695",
    s: "267831549193425768854967132326584971948713256571296384439652817685179423712348695",
    d: -33820,
  },
  {
    p: "260009475413067002095248136924010350870903210350024907130005700649372581587491623",
    s: "268139475413567892795248136924716358876953214351824967132685749649372581587491623",
    d: -33820,
  },
  {
    p: "260140973305062180401703025859030061136809452724051039642510308980026510010398246",
    s: "268145973375962184491783625859234761136879452724651839642517398983426517517398246",
    d: -33820,
  },
  {
    p: "068705040501092006973804521017950682892076100356128097789640203124530968605280710",
    s: "268715349541392876973864521417953682892476135356128497789641253124537968635289714",
    d: -33820,
  },
  {
    p: "200930410591806327073005896349582701850610940020470503604751209030264078712398654",
    s: "268937415591846327473125896349582761857613942126479583684751239935264178712398654",
    d: -33820,
  },
  {
    p: "269005708578623140041897206483512960612309584957468321704906815836700092005000000",
    s: "269145738578623149341897256483512967612379584957468321724936815836751492195284673",
    d: -33820,
  },
  {
    p: "069570401100240509305916872978460213512037046430102758050600000093784125824351697",
    s: "269578431187243569345916872978465213512837946436192758751629384693784125824351697",
    d: -33820,
  },
  {
    p: "269831005480795230730620891018207563600003984540968127390010478074309652002076319",
    s: "269831745481795236735624891918247563627153984543968127396512478174389652852476319",
    d: -33820,
  },
  {
    p: "271365049348007615569401320904030701612804590053916480095728136137640050006053904",
    s: "271365849348297615569481327984532761612874593753916482495728136137649258826153974",
    d: -33820,
  },
  {
    p: "270304900640521830805096421708142693300608712162903084920415008583007140407839256",
    s: "271384965649521837835796421758142693394658712162973584926415378583267149417839256",
    d: -33820,
  },
  {
    p: "271089056804671209060040071708060524645802307032754960423910785507438690986027043",
    s: "271389456854671239369245871798163524645892317132754968423916785517438692986527143",
    d: -33820,
  },
  {
    p: "271400893680032070940817020139685700452090160768100350327060900894271635516349287",
    s: "271456893685932471943817526139685742452793168768124359327568914894271635516349287",
    d: -33820,
  },
  {
    p: "273000904108794532054012080649205801731869245025471309382006150417503698500100423",
    s: "273658914168794532954312786649235871731869245825471369382946157417523698596187423",
    d: -33820,
  },
  {
    p: "073864519840912760096507024700051406358020071614098352067045108400103695031689247",
    s: "273864519845912763196537824729351486358426971614798352967245138482173695531689247",
    d: -33820,
  },
  {
    p: "273891045106005090950206107561403079832609514794512368089100453305060780407058926",
    s: "273891645146735892958246137561483279832679514794512368689127453325964781417358926",
    d: -33820,
  },
  {
    p: "274506801901084506865901423100359760500000102340612958628195047019700085753468219",
    s: "274536891931284576865971423182359764596847132347612958628195347419723685753468219",
    d: -33820,
  },
  {
    p: "274580061103426850865371920518640092647092538009058416486910000751200000032867145",
    s: "274589361193426857865371924518643792647192538329758416486915273751234689932867145",
    d: -33820,
  },
  {
    p: "274895600639042058105630024003750069918020305567380142391260007052903416706518293",
    s: "274895631639142758185637924423751869918426375567389142391264587852973416746518293",
    d: -33820,
  },
  {
    p: "074901005050230967690850120769105300315420780842379016021790603507640291936512478",
    s: "274961835158234967693857124769185342315426789842379516421798653587643291936512478",
    d: -33820,
  },
  {
    p: "270908300608714905941200867062800431000020700803071652329180546157643289486592173",
    s: "275968314638714925941235867762859431514326798893471652329187546157643289486592173",
    d: -33820,
  },
  {
    p: "270003908500967230493812650105206783827035490639008001750600349064580172912374865",
    s: "276453918581967234493812657145296783827135496639748521758621349364589172912374865",
    d: -33820,
  },
  {
    p: "076813459834952107051467082300029876689375204120608000008500901010096748492781635",
    s: "276813459834952167951467382345129876689375214127648593768534921513296748492781635",
    d: -33820,
  },
  {
    p: "070010845510006390349857120857162439100098572492735600680309204024681750730524960",
    s: "276913845518246397349857126857162439163498572492735681685379214924681753731524968",
    d: -33820,
  },
  {
    p: "070914038491538026083062419815079342302485197740023605004856001627390000108207963",
    s: "276914538491538726583762419815679342362485197749123685934856271627391854158247963",
    d: -33820,
  },
  {
    p: "208105903403920510591803072030452197947306800152089346309000254685204701724031689",
    s: "278145963463927518591863472836452197947316825152789346319678254685294731724531689",
    d: -33820,
  },
  {
    p: "278150000050603872406728001760392185182504396593016724620081537047005210015207649",
    s: "278159463951643872436728951764392185182574396593816724629481537347965218815237649",
    d: -33820,
  },
  {
    p: "278903006063051748005760320857004132040182075192370684529000463004026891681439257",
    s: "278943516963251748415768329857694132346182975192375684529817463734526891681439257",
    d: -33820,
  },
  {
    p: "278940310395176248604238950120497830480023601950800472532019704849050163760000029",
    s: "278945316395176248614238957126497835487523691953861472532619784849752163761384529",
    d: -33820,
  },
  {
    p: "279163480654782391810945702591470038027831950386259140738514620900320800000000073",
    s: "279163485654782391813945762591476238427831956386259147738514629965327814142698573",
    d: -33820,
  },
  {
    p: "279405008410362950030000142507186403304579620196234075753648210941023506862900034",
    s: "279415368418362957635897142527186493384579621196234875753648219941723586862951734",
    d: -33820,
  },
  {
    p: "281346975004195862960287030790000613436008027510760089153820700040609251629571348",
    s: "281346975374195862965287134798452613436918527512763489153824796847639251629571348",
    d: -33820,
  },
  {
    p: "201497005005623070670018940140706359800934720030102486324001597960375214517249863",
    s: "281497635495623178673518942142786359856934721739152486324861597968375214517249863",
    d: -33820,
  },
  {
    p: "281645300954270681360098254049027103028430790173956842000314508005702930800569417",
    s: "281645379954273681367198254549827163628431795173956842796314528415782936832569417",
    d: -33820,
  },
  {
    p: "281950640934861527760400800420306059356149080179280064810004235602513400543028916",
    s: "281957643934861527765432891428376159356149782179285364817694235692513478543728916",
    d: -33820,
  },
  {
    p: "283065490017900835549183607896571243405832910102609050358296174961050002004008069",
    s: "283765491617924835549183627896571243475832916132649758358296174961457382724318569",
    d: -33820,
  },
  {
    p: "284706159351009026907000480416293070890457631570168290725310900648905312030082547",
    s: "284736159351849726967521483416293875892457631573168294725314968648975312139682547",
    d: -33820,
  },
  {
    p: "285306007617542030930718050342179568896253014501004293109030426408921375700000981",
    s: "285396147617542839934718652342179568896253714571684293159837426468921375723465981",
    d: -33820,
  },
  {
    p: "285013607701690400469800013004037869003050020672984531316708945528040176947561382",
    s: "285413697731692458469875213154237869893156724672984531316728945528349176947561382",
    d: -33820,
  },
  {
    p: "205716034463002700719308250834967510000280073107430698690854320070029145542173869",
    s: "285716934463592781719348256834967512956281473127435698691854327378629145542173869",
    d: -33820,
  },
  {
    p: "280403000140250607957618203020004798031920465400586321518342970364795012792861500",
    s: "286473159143259687957618243625134798831927465479586321518342976364795812792861534",
    d: -33820,
  },
  {
    p: "286710300470000691915340270609523807800097460731060529564001782107450936398672154",
    s: "286719345473285691915346278649523817852197463731864529564931782127458936398672154",
    d: -33820,
  },
  {
    p: "280734195374100820109800743007251300593640010021003458015080032468329571932517684",
    s: "286734195374195826159862743847251369593648217621973458715486932468329571932517684",
    d: -33820,
  },
  {
    p: "200091000301546890594208067053014729900670403847329516709083054468957001135462978",
    s: "286791345371546892594238167653814729912675483847329516729183654468957231135462978",
    d: -33820,
  },
  {
    p: "087006590914380000005270140562907804800021635143568279326814957798653421451790000",
    s: "287146593914385762635279148562937814879421635143568279326814957798653421451792386",
    d: -33820,
  },
  {
    p: "200063954069070810104859627072046500010527489490301276756412398048035160320098745",
    s: "287163954569274813134859627872946531613527489495381276756412398948735162321698745",
    d: -33820,
  },
  {
    p: "287345091405190782601870350370024100106780029850900400908407203514238976723619845",
    s: "287345691435196782691872354379524168146783529852961437968457213514238976723619845",
    d: -33820,
  },
  {
    p: "207490510090715806060283479940150768756809030820630954009368140612970305430521697",
    s: "287496513394715826165283479943152768756849231821637954579368142612974385438521697",
    d: -33820,
  },
  {
    p: "007501439953240601164703250502619084700432016001057302479086125300920840825174963",
    s: "287561439953248671164793258532619784798432516641857392479386125316925847825174963",
    d: -33820,
  },
  {
    p: "287050314000400980509018270096283541802174639003569728025641007970830102168792453",
    s: "287956314631427985549318276796283541852174639413569728325641897974835162168792453",
    d: -33820,
  },
  {
    p: "287065431356041897491078502139056248768024953020039176840000009612493000075082310",
    s: "287965431356241897491378562139756248768124953524839176843517629612493785975682314",
    d: -33820,
  },
  {
    p: "289135740430967012617280000063051904972803651054602387006428135541379200028506400",
    s: "289135746435967812617284593863751924972843651154692387796428135541379268328516479",
    d: -33820,
  },
  {
    p: "080451637601739824730268015065042091170600452492517386840005170517906203923074000",
    s: "289451637651739824734268915365842791178693452492517386846325179517986243923174568",
    d: -33820,
  },
  {
    p: "280637100476000009135209780090073452040956803510428907967815320850390671321764598",
    s: "289637145476581239135249786698173452742956813513428967967815324854392671321764598",
    d: -33820,
  },
  {
    p: "200600175751809300603170802872350619506900207914007038468002950327596481195438726",
    s: "289643175751829364643175892872354619536981247914267538468712953327596481195438726",
    d: -33820,
  },
  {
    p: "290057864000160020365428719628010907049732601130096245050073098973280450816945372",
    s: "291357864784169523365428719628514937549732681137896245452673198973281456816945372",
    d: -33820,
  },
  {
    p: "291004075365897420704210369946782513820100794100943080419028637072431950008079002",
    s: "291364875365897421784215369946782513823156794157943286419528637672431958538679142",
    d: -33820,
  },
  {
    p: "001635708638107920475020001109780056057260093062090187523906004914378562786452319",
    s: "291635748638147925475829631149783256857261493362594187523916874914378562786452319",
    d: -33820,
  },
  {
    p: "291004057035972860687513902856000094023459186914820003542097638300000405168345729",
    s: "291684357435972861687513942856731294723459186914826573542197638379268415168345729",
    d: -33820,
  },
  {
    p: "293140586751968324840032907062053791579400830038729605980275160600094008305600479",
    s: "293147586751968324846532917462853791579416832138729645984275163617394258325681479",
    d: -33820,
  },
  {
    p: "293005007804029305051308629028514790915607203070032058009070562547296831632851974",
    s: "293165487864729315751348629328514796915687243476932158189473562547296831632851974",
    d: -33820,
  },
  {
    p: "293010600560020490800956732018672049975340006024195003159064087432780965786539124",
    s: "293417658567823491841956732318672549975348216624195873159264387432781965786539124",
    d: -33820,
  },
  {
    p: "203085716010926830058173029960854073800791652005360984520608390780500241349217508",
    s: "293485716417926835658173429962854173834791652175362984521648397786539241349217568",
    d: -33820,
  },
  {
    p: "293560817584137290760892300900021704018005029472680103805716902107003508639258471",
    s: "293564817584137296761892345956321784318475629472689153845716932127943568639258471",
    d: -33820,
  },
  {
    p: "293005670876123904541706832050410260037500009402639580380061045060974328724358196",
    s: "293845671876123954541796832958417263637582419412639587389261745165974328724358196",
    d: -33820,
  },
  {
    p: "200856700067940203480327695305210940046570800900634571754182069839405127002793458",
    s: "293856714567941283481327695375218946146579832928634571754182369839465127612793458",
    d: -33820,
  },
  {
    p: "204760513100050869658903724502897340981034270347001698716345980409206007820170430",
    s: "294768513173452869658913724562897341981634275347521698716345982439286157825179436",
    d: -33820,
  },
  {
    p: "295081476468509123307046905053408012742910038186732509829150364531024097000093000",
    s: "295381476468579123317246985953468712742915638186732549829157364531624897674893251",
    d: -33820,
  },
  {
    p: "005007060614832907738096421076180245450609180301200670127948536840360712563021890",
    s: "295417368614832957738596421976183245452679183381254679127948536849365712563721894",
    d: -33820,
  },
  {
    p: "290807600073564291401003007006971842724638015900452376142385769687129403509706000",
    s: "295817634873564291461293587356971842724638915918452376142385769687129453539746128",
    d: -33820,
  },
  {
    p: "290108540834570900015040386063415728107829653582307194329004860608090405001683279",
    s: "296138547834576912715942386963415728147829653582367194329754861678291435451683279",
    d: -33820,
  },
  {
    p: "206107034003800615805600097008002950542396080031578426380261579627935148159704362",
    s: "296157834473829615815643297768412953542396781931578426384261579627935148159784362",
    d: -33820,
  },
  {
    p: "296058374807469021451030089164290850920517036075846912503074268040685193609020000",
    s: "296158374837469521451732689164293857928517436375846912513974268742685193689321745",
    d: -33820,
  },
  {
    p: "290845107051237496074961825710683040060529781982170650507496018029758360640000500",
    s: "296845137851237496374961825715683942463529781982174653537496218129758364648312579",
    d: -33820,
  },
  {
    p: "207340016845107293160500784938706025021834967674295108000451609019673852756000001",
    s: "297348516845167293163529784938716425521834967674295138382451679419673852756982341",
    d: -33820,
  },
  {
    p: "290000018418507006360198047059206473602000090783905621901862750576419382824753169",
    s: "297634518418527936365198247159286473642371895783945621931862754576419382824753169",
    d: -33820,
  },
  {
    p: "312684097904735128508190634821963005039058206056071000193047860285306740607829300",
    s: "312684597964735128578192634821963475739458216456271983193547862285316749647829351",
    d: -33820,
  },
  {
    p: "312095684845136297076248031091460825058921473230587069020674018009000706467009300",
    s: "312795684845136297976248531791463825658921473234587169523674918189352746467819352",
    d: -33820,
  },
  {
    p: "314520060006389174070106523700635002835290710042071930107453098423918657509762340",
    s: "314527869256389174978146523791635482835294716642871935167453298423918657589762341",
    d: -33820,
  },
  {
    p: "314870096697003821208109003402615089589327064003984205920038417831740952745200600",
    s: "314872596697453821258169743472615389589327164163984275926538417831746952745291638",
    d: -33820,
  },
  {
    p: "005208794760109835049530012900726048274381069601405320438602071096874053520013486",
    s: "315268794762149835849537612953726148274381569681495327438652971196874253527913486",
    d: -33820,
  },
  {
    p: "315600249870025060290314700087536412023471598451890073509268107108753924702100006",
    s: "315687249874925361296314785987536412623471598451892673549268137168753924732149856",
    d: -33820,
  },
  {
    p: "310792480200408531406513297169847000023050904754329018640075120900100765571236849",
    s: "315792486297468531486513297169847352823651974754329618648975123932184765571236849",
    d: -33820,
  },
  {
    p: "300900278896000010420158090540782169970631085168495327759200801280519006631874952",
    s: "315946278896327514427158693543782169972631485168495327759263841284519736631874952",
    d: -33820,
  },
  {
    p: "015904076728506409964721350241863507637459821089172643800017030476390182190000000",
    s: "315984276728536419964721358241863597637459821589172643852617934476395182193248765",
    d: -33820,
  },
  {
    p: "306245870924807350785693124600480790247300681508761000859000037072004568463578912",
    s: "316245879924817356785693124631482795247359681598761243859126437172934568463578912",
    d: -33820,
  },
  {
    p: "016420795900507621000169834009810540864970002135600978681790053570380469493256187",
    s: "316428795948537621257169834729813546864975312135642978681794253572381469493256187",
    d: -33820,
  },
  {
    p: "310054980782910435945238017071620340000871256028543791850367124204090803107400069",
    s: "316754982782916435945238617571629348493871256628543791859367124264195873137482569",
    d: -33820,
  },
  {
    p: "306900420429680735578423910900508162635214879102700354294075681863142500700006200",
    s: "316957428429681735578423916947538162635214879182769354294375681863142597751896243",
    d: -33820,
  },
  {
    p: "317862405602479318408503007800005769009186530003927801934258176180794203275000984",
    s: "317862495652479318498513627821345769749186532563927841934258176186794253275631984",
    d: -33820,
  },
  {
    p: "310650279004090030090387600847025000920416857056738924475861092631279485289500716",
    s: "318654279764192538592387641847925163923416857156738924475861392631279485289543716",
    d: -33820,
  },
  {
    p: "310050600547683109902170583056701934174369052093040016039806270021495368685230490",
    s: "318952647547683129962174583856721934174369852293548716439816275721495368685237491",
    d: -33820,
  },
  {
    p: "319085467854376192060149080530061924941023608627804310400010230083952746290000851",
    s: "319285467854376192762149583538761924941523678627894315475618239183952746296437851",
    d: -33820,
  },
  {
    p: "309580070257034906846092315478600100102075048063418020624957831730861204901043567",
    s: "319586472257134986846792315478629153192375648563418729624957831735861294981243567",
    d: -33820,
  },
  {
    p: "021068594006035127590401680874213956612597430903846071130602845745189362008000000",
    s: "321768594486935127597421683874213956612597438953846271139672845745189362268354719",
    d: -33820,
  },
  {
    p: "021050947090432001540170623259013874163048090074925316600090050907581462485267139",
    s: "321856947796432581548179623259613874163748295874925316612394758937581462485267139",
    d: -33820,
  },
  {
    p: "301857009694010008805946213139684502482305961007100380053401006006538427248769135",
    s: "321857649694213758875946213139684572482375961567192384753421896916538427248769135",
    d: -33820,
  },
  {
    p: "324687159960315080185049037458923016031050892206871540673598421009100378012000005",
    s: "324687159967315284185249637458923716731456892296871543673598421549162378812734965",
    d: -33820,
  },
  {
    p: "324896175910203486856400930792184563460735291100020740241360000679518324503900000",
    s: "324896175917253486856471932792184563468735291135629748241367859679518324583942617",
    d: -33820,
  },
  {
    p: "324976158580301064067845003806213045012584376453697020690130487241000000738460012",
    s: "324976158589321764167845293876213945912584376453697821695132487241758639738469512",
    d: -33820,
  },
  {
    p: "025798600741653800980241375290186537070329006100504098010435960609802054452967183",
    s: "325798641741653829986241375294186537578329416163574298817435962639812754452967183",
    d: -33820,
  },
  {
    p: "325000108104035269860002035708029641546371980291680000902060703483197526617253894",
    s: "325946178174835269869712435738529641546371982291684357952468713483197526617253894",
    d: -33820,
  },
  {
    p: "306045978508679200049200165030096521080027604052314897805463002203701489174982356",
    s: "326145978518679243749238165437896521981527634652314897895463712263751489174982356",
    d: -33820,
  },
  {
    p: "026179084700064093400325076835710429204098361069432708012953847980247615547600000",
    s: "326179584751864293498325176835716429274598361169432758612953847983247615547681932",
    d: -33820,
  },
  {
    p: "006098000078352601100764032754039086203817954981040003807926310519473268632581470",
    s: "326198547478352691195764832754239186263817954981645723847926315519473268632581479",
    d: -33820,
  },
  {
    p: "006478915485009007791352468564031092930627150217090603600283570800900346053746829",
    s: "326478915485169237791352468564831792938627154217594683649283571872915346153746829",
    d: -33820,
  },
  {
    p: "027490058951382746408157923570900080209708061816045079180520607690873014732614800",
    s: "327496158951382746468157923573961482249738561816245379184529637695873214732614895",
    d: -33820,
  },
  {
    p: "327500060968213047015087230706835092809420670152769480201946058580002016093158724",
    s: "327594861968213547415687239746835192839421675152769483271946358584372916693158724",
    d: -33820,
  },
  {
    p: "320471596647259308100683427273948651086015740514760080430520809700804100859000264",
    s: "328471596647259318195683427273948651986315742514762983431526879762894135859137264",
    d: -33820,
  },
  {
    p: "308491706609075831071683294914368007867529403253107968400912005102754600000030142",
    s: "328491756649275831571683294914368527867529413253147968486912375132754689795836142",
    d: -33820,
  },
  {
    p: "328571964954086713176300002815700009607942581090000637560419278741825300080037145",
    s: "328571964954286713176394852815763429637942581492158637563419278741825396289637145",
    d: -33820,
  },
  {
    p: "329400781860702049471983265038547006540020903702030804107360502653290017294175638",
    s: "329456781865712349471983265938547126546821973712639854187364592653298417294175638",
    d: -33820,
  },
  {
    p: "320567048010928650600413092590080436160204987874639521701095260936140875005876010",
    s: "329567148417928653658413792592781436163254987874639521781395264936142875245876319",
    d: -33820,
  },
  {
    p: "320800147087003960005091208003265794592347681706189523054978312938000476001634850",
    s: "329856147187423965465791238813265794592347681746189523654978312938512476271634859",
    d: -33820,
  },
  {
    p: "341250870005094306698107542409318250802975463703042981580703104124560738900480005",
    s: "341256879275894316698137542469318257812975463753642981586723194124569738937481625",
    d: -33820,
  },
  {
    p: "041200875697010234528043061073056192089030756105072048816305420900480613734621509",
    s: "341269875697518234528743961473856192289134756165972348816395427952487613734621589",
    d: -33820,
  },
  {
    p: "340096758927835641865714030213589007574361829600400005132907086706153294450000070",
    s: "341296758927835641865714932213589467574361829698472315132947586786153294459628173",
    d: -33820,
  },
  {
    p: "341090006869045201257316004685029347174563900932407600420601500013958062096274183",
    s: "341892756869745231257316894685129347174563928932487615428631579713958462596274183",
    d: -33820,
  },
  {
    p: "302678915065019237170523468530841792721935840904267153250180670000000020017002584",
    s: "342678915865419237179523468536841792721935846984267153253184679498756321617392584",
    d: -33820,
  },
  {
    p: "342781960980245137017600208120859004708416320409027581035072416270060890694108052",
    s: "342781965986245137517693248123859674758416329469327581835972416271564893694138752",
    d: -33820,
  },
  {
    p: "342789165198050230576031009685317920007408603039062008754806091963100870021973546",
    s: "342789165198654237576231489685317924217498653439562718754826391963145872821973546",
    d: -33820,
  },
  {
    p: "042070659791260843865090712417982006600734280238150074100049028980027165503610497",
    s: "342871659791265843865493712417982536659734281238156974176549328984327165523618497",
    d: -33820,
  },
  {
    p: "302005108590107346167384925200806793906250010010749562689430257431572689725090000",
    s: "342965178598127346167384925254816793976253814813749562689431257431572689725698431",
    d: -33820,
  },
  {
    p: "345106872906723040712580930574208609863900720129670480207019004000452197491367250",
    s: "345196872986723541712584936574238619863941725129675483257819364638452197491367258",
    d: -33820,
  },
  {
    p: "345200079018694050200007104539076420420905316601430790162849537953760842874523001",
    s: "345218679718694253296357184539176428427985316681432795162849537953761842874523961",
    d: -33820,
  },
  {
    p: "345286970180300002270901005902060517407000398850790426518437269694108753723059184",
    s: "345286971189375642276941835932864517467512398851793426518437269694128753723659184",
    d: -33820,
  },
  {
    p: "305789020800412539920563748500640893413958267698030450130800975080370010756104382",
    s: "345789126867412539921563748572641893413958267698237451134826975289375614756194382",
    d: -33820,
  },
  {
    p: "345900021021375694769124503904803215618207340053409006507091432400538000036742958",
    s: "345986721821375694769124583974863215618257349253419876587691432492538167136742958",
    d: -33820,
  },
  {
    p: "346791805710802643580003197907628314004017006061930072093206758608175439475389000",
    s: "346791825719852643582463197957628314234517986861934572193246758628175439475389261",
    d: -33820,
  },
  {
    p: "306875129529614378170329060000987643687200050934560782751492830060108597893700000",
    s: "346875129529614378178329465215987643687243951934561782751492836462138597893756214",
    d: -33820,
  },
  {
    p: "040009862210487905985236174423098756569700318800653249690341027732000480004802093",
    s: "347519862216487935985236174423198756569724318871653249698341527732965481154872693",
    d: -33820,
  },
  {
    p: "308210790917354600056089043190465278705032460462008539639541827524890316871000000",
    s: "348216795917354682256789143193465278785932461462178539639541827524897316871623954",
    d: -33820,
  },
  {
    p: "348612950156973842072400163604027501781549326503860094065008279219056038830200000",
    s: "348612957156973842972485163694327581781549326523861794465138279219756438837294615",
    d: -33820,
  },
  {
    p: "340210076800367419176405083250689730708142060094573008982030651063921840417006392",
    s: "349218576825367419176495283251689734738142965694573128982734651563921847417856392",
    d: -33820,
  },
  {
    p: "309271586520638149186594307902060400873412965610900238401009750090705603735006894",
    s: "349271586527638149186594327952863471873412965614957238461389752298745613735126894",
    d: -33820,
  },
  {
    p: "300800276186002530270906180012604300958010467634587912803169045467325891591078003",
    s: "349851276186742539275936184712694358958213467634587912823169745467325891591478623",
    d: -33820,
  },
  {
    p: "351724968740019235892063400689031574407690823235078196164057382020106040000000651",
    s: "351724968746819235892563417689231574417695823235478196164957382523186749978342651",
    d: -33820,
  },
  {
    p: "302481709680200000401307080915024036006159472724638901178946523269573148540810007",
    s: "352481769687295314491367285915724836836159472724638951178946523269573148543812697",
    d: -33820,
  },
  {
    p: "002847016487019350691325004065030140900400003140072698806203479524796831739184265",
    s: "352847916487619352691325784265938147978461523143572698816253479524796831739184265",
    d: -33820,
  },
  {
    p: "054178620801920430062345187783060290629813574415792803100600952206059708007281006",
    s: "354178629871926435962345187783564291629813574415792863148637952236459718597281346",
    d: -33820,
  },
  {
    p: "350270098289600741070048352460052189592800436800496075148563927705009064026784503",
    s: "354271698289635741671948352467352189592817436813496275148563927735129864926784513",
    d: -33820,
  },
  {
    p: "054281709206903501170006038002365180530798624867104395918607452700002016025419873",
    s: "354281769286973541179546238492365187531798624867124395918637452743852916625419873",
    d: -33820,
  },
  {
    p: "350040001827516904000308256742083100005924387983107642430790568568431029279865010",
    s: "356249871827516934194378256742683195615924387983157642431792568568431729279865413",
    d: -33820,
  },
  {
    p: "350207490000453687400916325847162539020045006561398742604500278180670003735809164",
    s: "356287491219453687478916325847162539923745816561398742694531278182674953735829164",
    d: -33820,
  },
  {
    p: "350291487820574610174836502691042075530907164700160230017623908903450700285000346",
    s: "356291487829574613174836592691342875532987164748165239417623958963458721285719346",
    d: -33820,
  },
  {
    p: "307298106820014350641075900573941628084700519096852473000029000912583760408167295",
    s: "357298146829614357641375982573941628284736519196852473765429831912583764438167295",
    d: -33820,
  },
  {
    p: "050290401206501807801647235518079600030015740079306518064003182085162374123784956",
    s: "357298461246531897891647235518479623632815749479326518764953182985162374123784956",
    d: -33820,
  },
  {
    p: "357421896289000001410978532564010903000895460970640215890267304003159628625304109",
    s: "357421896289536741416978532564712983132895467978643215891267354743159628625384179",
    d: -33820,
  },
  {
    p: "357802400210395876069071250600530190905124630031689042108203064403716900576948321",
    s: "357862419214395876869471253642537198985124637731689542198253764423716985576948321",
    d: -33820,
  },
  {
    p: "308142796409563802060870534003218060726394058814706320930087245247905680080401073",
    s: "358142796479563812162879534593218467726394158814756329931687245247935681685421973",
    d: -33820,
  },
  {
    p: "308002796609783501120596084510470002964250130070030945090804213280315479431927658",
    s: "358142796649783521127596384513479862964258137872631945795864213286315479431927658",
    d: -33820,
  },
  {
    p: "358140709209738054706025083102589467087062030564307892491603270623874015000200346",
    s: "358146729219738654746925183132589467987462531564317892491653278623874915875291346",
    d: -33820,
  },
  {
    p: "008261709604500108000348062002137984780492603409056210875624391946713025210085476",
    s: "358261749624579138197348562562137984781492653439856217875624391946713825213985476",
    d: -33820,
  },
  {
    p: "050946207001008940907320865709014008265893174184257639013769452096432781470180000",
    s: "358946217621578943947321865739614528265893174184257639813769452596432781472185396",
    d: -33820,
  },
  {
    p: "350904710601273400204180639827459361069800520503621987400002000015348276782596143",
    s: "358964712691273458274185639827459361169837524543621987436712895915348276782596143",
    d: -33820,
  },
  {
    p: "359418070001729803728603041010005020567180439200940060075836204836294517492571386",
    s: "359418672641729853728653941914365728567182439283947165175836294836294517492571386",
    d: -33820,
  },
  {
    p: "301045089480902153905310746146297508503684910298153600812470395009801000004529861",
    s: "361745289487962153925318746146297538573684912298153674812476395659831427734529861",
    d: -33820,
  },
  {
    p: "360025000879364005405718069718490536094036012032007048046500891103289674987641253",
    s: "361925487879364125425718369718492536594836712632157948246573891153289674987641253",
    d: -33820,
  },
  {
    p: "360952840582040930049801020415320768973600002820075394238407516057263480694518200",
    s: "361952847582746931749831625415329768973684152826175394238497516157263489694518273",
    d: -33820,
  },
  {
    p: "361972580950483760874650302536047129249310805718529643187234056625108400000000000",
    s: "361972584952483761874651392536847129249316875718529643187234956625198437493765218",
    d: -33820,
  },
  {
    p: "302087495804096173719054200073068501098542000500731948041673059037805604685419732",
    s: "362187495854296173719354286473968521198542367526731948241673859937825614685419732",
    d: -33820,
  },
  {
    p: "302491870907680132518732640436910008079250300201068400603109504780523901195846723",
    s: "362491875947685132518732649436917258879254316251368497623179584784523961195846723",
    d: -33820,
  },
  {
    p: "362740951100932640498615237871293560920451783504067002203580470689170325000000016",
    s: "362748951157932648498615237871293564926451783534867192213586479689174325745329816",
    d: -33820,
  },
  {
    p: "360100875852037004917840203629014758040768932003592641230006500075983006496251387",
    s: "364129875852637194917845263629314758541768932783592641238476519175983426496251387",
    d: -33820,
  },
  {
    p: "365418079798200314012397586809645023106003940043189657501970062020801700687500491",
    s: "365418279798256314412397586879645123156723948243189657531974862924861735687532491",
    d: -33820,
  },
  {
    p: "065020480784390612012086053653140297491270568278560104546930870129800346800004025",
    s: "365721489784395612912486753653148297491273568278569134546932871129857346837614925",
    d: -33820,
  },
  {
    p: "305020000040009360927460851289305607014080003500947218692158734871634925453792186",
    s: "365821479148579362927463851289315647714286593536947218692158734871634925453792186",
    d: -33820,
  },
  {
    p: "365847021000615374174932506803700092017300045096428013721593468630284150458170000",
    s: "365847921982615374174932586843751692217369845596428713721593468639284157458176239",
    d: -33820,
  },
  {
    p: "307082945205439017041670023098503764720810539534967182412758396873200000650301000",
    s: "367182945285439617941675823198523764726814539534967182412758396873296451659341278",
    d: -33820,
  },
  {
    p: "360845020814927365509106040080210039190650478450798602601582794245370086008461250",
    s: "367845921814927365529136847786214539192653478453798612631582794245379186978461253",
    d: -33820,
  },
  {
    p: "367012458095803260204500109051468723708205910032791080870154602529687041416309005",
    s: "367912458195843267284576139951468723748235916632791584873154692529687341416329875",
    d: -33820,
  },
  {
    p: "368247509791508462524961387182050600973604051456810723809076235600092170030100040",
    s: "368247519791538462524961387182753694973624851456819723819476235645392178237185946",
    d: -33820,
  },
  {
    p: "360009107510087342002000960850974621406015870197062435685293714974156200201740596",
    s: "368429157519687342742531968853974621426315879197862435685293714974156283231748596",
    d: -33820,
  },
  {
    p: "368512004210870536705069128693105287582736901071928365104050800800297010900401652",
    s: "368512794219874536745369128693145287582736941471928365124653879856297413937481652",
    d: -33820,
  },
  {
    p: "068927541170340208054106900835694102012750086047218390000070653586430710793561824",
    s: "368927541179345268254186937835694172912753486647218395421879653586432719793561824",
    d: -33820,
  },
  {
    p: "060475218784921536250806409897100325130750894425389761943210607512640000608000100",
    s: "369475218784921536251836479897164325136752894425389761943218657512647983678593142",
    d: -33820,
  },
  {
    p: "070592460482700195659140300714826009263904871890371246930007004000089713147635982",
    s: "371592468482763195659148327714826539263954871895371246938217654526489713147635982",
    d: -33820,
  },
  {
    p: "300625849290180000508493027823974615006001290109056708432068971617349582980700463",
    s: "371625849294187356568493127823974615756831294149256738432568971617349582985712463",
    d: -33820,
  },
  {
    p: "372169504014387926689425730003604000450273108107090063901842070068951342205036819",
    s: "372169584514387926689425731893614257456273198127598463931842675768951342245736819",
    d: -33820,
  },
  {
    p: "070405691694001300501039720209843107800217450010096832126350978740968013938172546",
    s: "372485691694721385581639724259843167863217459417596832126354978745968213938172546",
    d: -33820,
  },
  {
    p: "002561084094208057080409132037146529409750000061982473716000248903820716248617395",
    s: "372561984194238657685479132837146529429753861561982473716395248953824716248617395",
    d: -33820,
  },
  {
    p: "370950184046103702851074063004068510538419276169700348285030490693540821407800035",
    s: "372956184946183752851274963724368519538419276169725348285631497693547821417892635",
    d: -33820,
  },
  {
    p: "304080102601742905209136084145097623708013459002405001593601048410320590826954317",
    s: "374589162681742935259136784145897623768213459932465871593671248417328596826954317",
    d: -33820,
  },
  {
    p: "004915820896072301125380074648000709700860240030041685903027468462138597587694130",
    s: "374915826896472351125386974648253719751869243239741685913527468462138597587694132",
    d: -33820,
  },
  {
    p: "375104698062508740480796305716203904029641537540987002297805413654312009008070050",
    s: "375124698962538741481796325716253984829641537543987162297865413654312879138479256",
    d: -33820,
  },
  {
    p: "005126498941583020268097051700361549513974802094250170429815600137049200050032014",
    s: "375126498941583726268497351782361549513974862694258173429815637137649285856732914",
    d: -33820,
  },
  {
    p: "375904682806702143421360005632540708009037056547680001013805064968400517204176839",
    s: "375914682896752143421368975632541798189237456547689321713895264968423517254176839",
    d: -33820,
  },
  {
    p: "075908216182370040906001738700035000019627583523804671290510867600702394837469152",
    s: "375948216182376945946251738768135429419627583523894671294513867651782394837469152",
    d: -33820,
  },
  {
    p: "376100098090400571400897632020914056049528017851006049960231785182745963037609120",
    s: "376152498298463571415897632723914856649528317851376249964231785182745963537689124",
    d: -33820,
  },
  {
    p: "076480150905071408040309076508943721700810604194007583419500300653794812287136945",
    s: "376482159925671438841359276568943721732815694194267583419528367653794812287136945",
    d: -33820,
  },
  {
    p: "300805924584072316091436857720193645403258179915760038030640502640581700807300400",
    s: "376815924584972316291436857728193645463258179915764238139647582642581793857329461",
    d: -33820,
  },
  {
    p: "300892000059400078001006392820067900765129483913008267132974856597683124648215700",
    s: "376892541259431678481756392824367915765129483913548267132974856597683124648215739",
    d: -33820,
  },
  {
    p: "376948512859312407410567839038004976005879341700601008583026004000190080961483725",
    s: "376948512859312467412567839138254976625879341794631258583726194247195683961483725",
    d: -33820,
  },
  {
    p: "308560291592017346146092758709003004034086510651429803820001937917238405460000182",
    s: "378564291592817346146392758789153624234786519651429873825641937917238465463975182",
    d: -33820,
  },
  {
    p: "370186425401705398058403761683574912527609804910038050146050283732061549800000006",
    s: "379186425461725398258493761683574912527619834914238657146957283732861549895342176",
    d: -33820,
  },
  {
    p: "009210508068507210250030407620450879040789326987326145836942051592173680704065900",
    s: "379214568468597213251638497623451879145789326987326145836942751592173684714865932",
    d: -33820,
  },
  {
    p: "009256810104789032002134607790021465518647029426090078940365081231008000685912743",
    s: "379256814164789532852134697793821465518647329426593178947365281231478956685912743",
    d: -33820,
  },
  {
    p: "370206801061340972824970065735460100196805407482010590013684700957132684648597000",
    s: "379256841561348972824971365735469128196825437482713596213684759957132684648597213",
    d: -33820,
  },
  {
    p: "379016428008427693264809157037090864601008239802064500080902310715680042923145780",
    s: "379516428158427693264839157537291864641758239892364571486972315715683942923145786",
    d: -33820,
  },
  {
    p: "009501462164302087825746139680954700410867925907210046541630270296478051738000000",
    s: "379581462164392587825746139682954713413867925957213846541639278296478351738125694",
    d: -33820,
  },
  {
    p: "309582641001630589608419203067891324824753100093264857782340915410920738000000060",
    s: "379582641241637589658419273567891324824753196193264857782346915416925738935178462",
    d: -33820,
  },
  {
    p: "370625004625804793000030250500940020230157948497203065183402570950371682762598431",
    s: "379625814625814793841739256518946327236157948497283165183462579954371682762598431",
    d: -33820,
  },
  {
    p: "080469057700153648605782019829310705007695832060027090138006020074531986956248173",
    s: "381469257792153648645782319829314765417695832563827491138976524274531986956248173",
    d: -33820,
  },
  {
    p: "381507264006280351240031087407052098512809743869470025100948000600715832758326409",
    s: "381597264976284351245631987437152698512869743869473125123948576694715832758326419",
    d: -33820,
  },
  {
    p: "301749206926350410475061098590106842000580730740920561830697100267415983159032600",
    s: "381749256926358417475261398593176842612584739748923561834697125267415983159832674",
    d: -33820,
  },
  {
    p: "382490651491500300567130000804960723935721460276843519149058237608374095700000046",
    s: "382497651491586372567132984814965723935721468276843519149658237628374195753219846",
    d: -33820,
  },
  {
    p: "384070596017089403592036017120008604075360280009245371046950000758613942931824765",
    s: "384172596617589423592436817123798654475361289869245371246957138758613942931824765",
    d: -33820,
  },
  {
    p: "384502970760489210291360400653024090847193650109050348572600839000038520938275164",
    s: "384512976765489213291367485653824791847193652129756348572641839416938527938275164",
    d: -33820,
  },
  {
    p: "380510902962748150005009480419600820758402361036085749503274600027901534601853297",
    s: "384516972962748153175329486419637825758492361236185749593274618827961534641853297",
    d: -33820,
  },
  {
    p: "004015926906428010217930048408697135173050860069381204802063791005142680601879450",
    s: "384715926956428317217936548428697135173254869569381274842563791795142683631879452",
    d: -33820,
  },
  {
    p: "380065921051329700297041030402658179579130640168970250903007460706013005845296317",
    s: "384765921651329784297841536432658179579132648168974253913587462726413895845296317",
    d: -33820,
  },
  {
    p: "084971625600040080720500001190654073005100064430287150967425318218739546543816792",
    s: "384971625651342987729568431192654873875193264436287159967425318218739546543816792",
    d: -33820,
  },
  {
    p: "304972061016503240502640983893706052247300619601409038469837125028165000030204876",
    s: "384972561916583247572641983893716452247358619651429738469837125728165394135294876",
    d: -33820,
  },
  {
    p: "386410009709560024254780163437805612592136408100274905073658241040921300800007596",
    s: "386412759719563824254789163437895612592136478168274935973658241645921387821347596",
    d: -33820,
  },
  {
    p: "307452109190830407026091080570900210260547800940103706710684532634205978852379641",
    s: "387452169195836427426791385573968214261547893948123756719684532634215978852379641",
    d: -33820,
  },
  {
    p: "087010492204389700950472038473698015821035009569240387630824970008000024142957863",
    s: "387516492214389756956472138473698215821735649569241387635824971798163524142957863",
    d: -33820,
  },
  {
    p: "009506200264071358170820496950107024600405713417208965036759102592304687741602009",
    s: "389546271264971358175823496953167824628495713417238965836759142592314687741682539",
    d: -33820,
  },
  {
    p: "391084502028000609456902103635048010912063408874519320289456030143807200067321894",
    s: "391684572728135649456972183635248917912763458874519326289456731143897265567321894",
    d: -33820,
  },
  {
    p: "301754608476298301825063704039400080100932475240810960903021547012540039754380216",
    s: "391754628476298351825163794539476182168932475247815963983621547612547839754389216",
    d: -33820,
  },
  {
    p: "392064710804219506651807249210496075540328000906075423029081057700943080130752694",
    s: "392564718874219536651837249213496875547328961986175423429681357765943182138752694",
    d: -33820,
  },
  {
    p: "390710040008953001071462980640089310213045890985301402024130759736594128159807630",
    s: "392718546468953271571462983647289315213645897985371462824136759736594128159827634",
    d: -33820,
  },
  {
    p: "094207508007835942502946307073602104015403876649178203456389701731024689920001000",
    s: "394217568167835942582946317873652194215493876649178253456389721731524689928761435",
    d: -33820,
  },
  {
    p: "394080000268940573571062849705203681680415702100678054410706398037024105056039427",
    s: "394587216268941573571362849745293681689415732123678954412756398937824165856139427",
    d: -33820,
  },
  {
    p: "094615278167382000852049036903076021006238459508090360231857690685924713070000582",
    s: "394615278167382945852749136943576821716238459528491367231857694685924713479163582",
    d: -33820,
  },
  {
    p: "094056002006042398012937465500001084480325976620098531963584127108273650075610043",
    s: "394856712756142398812937465539761284481325976627498531963584127148273659275619843",
    d: -33820,
  },
  {
    p: "000180070600295300080637945142970500763518429958423167436751892027849631019360000",
    s: "395184276674295318281637945142976583763518429958423167436751892527849631819362754",
    d: -33820,
  },
  {
    p: "395020807081300402207819536004090053839065271506730984400583709753906128968102345",
    s: "395624817681357492247819536174298653839465271526731984412583769753946128968172345",
    d: -33820,
  },
  {
    p: "395000471020137659170050302460582930987341506532706810709803040250400168648215793",
    s: "395628471824137659176954382461582937987341526532796814719863245253479168648215793",
    d: -33820,
  },
  {
    p: "005602007080510620210738549569400071871960432423871956158297364947306010632150000",
    s: "395642187784519623216738549569423871871965432423871956158297364947386215632154798",
    d: -33820,
  },
  {
    p: "306071845427056301581394672132948060008713409709025130210537900875409200000182754",
    s: "396271845427856391581394672132948567658713429749625138214537986875469213963182754",
    d: -33820,
  },
];
